import { IonSpinner } from '@ionic/react';
import styles from './Loader.module.scss';

export interface ILoaderProps {
   message?: string;
   centered?: boolean;
   mode?: 'light' | 'dark';
}

const Loader = ({ message, centered = true, mode = 'dark' }: ILoaderProps) => {
   return (
      <div
         className={`${centered && 'centered'} h-100`}
         id='loader-wrapper'
         resource-id='loader-wrapper'
         data-cy='loader-wrapper'
      >
         <div className='grid-item-center'>
            {message && <p className={`${mode === 'light' && 'text-white'} mb-0`}>{message}</p>}
            <IonSpinner
               className={mode === 'light' ? styles.lightSpin : styles.darkSpin}
               name='circles'
               id='loader'
               resource-id='loader'
               data-cy='loader'
            />
         </div>
      </div>
   );
};

export default Loader;
